module.exports = __webpack_public_path__ + "img/About_Employers_LIGHT-01.1fbb45d.svg";